export function setItem(scope: string, name: string, obj: any) {
    let type: string = typeof obj;

    if (obj instanceof Date) {
        type = "Date";
    }
    var ev = {
        type: type,
        data: obj,
    };
    localStorage.setItem(itemName(scope, name), JSON.stringify(ev));
}

function itemName(scope: string, name: string): string {
    return ["Ungapped", scope, name].join(".");
}
export function getItem(scope: string, name: string) {
    let thisItem = itemName(scope, name);

    let thisItemGet = localStorage.getItem(thisItem);
    if (thisItemGet != null) {
        let ParsedItem = JSON.parse(thisItemGet);
        if (ParsedItem.type != null && ParsedItem.type == "Date") {
            ParsedItem.data = new Date(ParsedItem.data);
        }

        return ParsedItem.data;
    } else {
        return null;
    }
}

export function removeItem(scope: string, name: string) {
    localStorage.removeItem(itemName(scope, name));
}

export function LocalStorageClear() {
    localStorage.clear();
}
